// TODO(dev:dashboard_v2): Remove this mock data file

export const MOCK_OPPORTUNITY_SIGNALS = [
  {
    id: 1,
    title: "Discover potential leads",
    visited: false,
    description:
      "CTOs at AI startups in North America are recommended based on recent campaign performance, where this segment showed strong engagement.",
    type: "hunter-suggestion" as const,
    entityType: "people" as const,
    entityCount: 25,
  },
  {
    id: 2,
    title: "New results for your search",
    visited: true,
    description:
      "VPs of Engineering at Series B SaaS Companies in Western Europe.",
    type: "new-result" as const,
    entityType: "companies" as const,
    entityCount: 12,
  },
  {
    id: 3,
    title: "Discover potential leads",
    visited: false,
    description:
      "Series B HR Tech companies across the United States are ramping up hiring and building out their revenue orgs. Sales leadership turnover suggests active evaluation of new tools and vendors in this segment.",
    type: "hunter-suggestion" as const,
    entityType: "people" as const,
    entityCount: 84,
  },
  {
    id: 4,
    title: "New results for your search",
    visited: false,
    description:
      "E-commerce companies with 50-200 employees in the United Kingdom actively hiring marketing talent.",
    type: "new-result" as const,
    entityType: "companies" as const,
    entityCount: 37,
  },
  {
    id: 5,
    title: "Discover potential leads",
    visited: true,
    description:
      "Fintech startups in seed to Series A stage showing rapid growth patterns. Recent funding announcements indicate increased budgets for sales and marketing technology.",
    type: "hunter-suggestion" as const,
    entityType: "companies" as const,
    entityCount: 19,
  },
  {
    id: 6,
    title: "New results for your search",
    visited: false,
    description:
      "B2B SaaS companies in the San Francisco Bay Area with active sales leadership positions.",
    type: "new-result" as const,
    entityType: "companies" as const,
    entityCount: 56,
  },
  {
    id: 7,
    title: "Discover potential leads",
    visited: false,
    description:
      "Revenue Operations leaders at companies using Salesforce are experiencing strong engagement rates. This segment has shown 40% higher response rates in similar campaigns.",
    type: "hunter-suggestion" as const,
    entityType: "people" as const,
    entityCount: 142,
  },
  {
    id: 8,
    title: "New results for your search",
    visited: true,
    description:
      "Series C healthcare technology companies expanding into new markets across North America and Europe.",
    type: "new-result" as const,
    entityType: "companies" as const,
    entityCount: 8,
  },
]

const now = new Date()
